module.exports = __webpack_public_path__ + "img/license.2b5662a3.svg";